import { render, staticRenderFns } from "./CollapseMultiSelect.vue?vue&type=template&id=53dcf44c&scoped=true&"
import script from "./CollapseMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./CollapseMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseMultiSelect.vue?vue&type=style&index=0&id=53dcf44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcf44c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VIcon,VListItemAction,VListItemContent,VListItemTitle})
